import * as React from "react";
import Button from "../UI/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { translate } from "../../utils/translations/translate";
import { useAuth } from "./hooks/useAuth";
import { useDispatch } from "react-redux";
import { userActions } from "../../store/actions";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export function SessionExpiredModal() {
  const [open, setOpen] = React.useState(true);
  const {logoutUser} = useAuth();
  const dispatch = useDispatch();
  const handleClose = () => {
    setOpen(false);
    dispatch(userActions.setShowExpiryModal(false));
    logoutUser();
  };

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {translate("labels.sessionExpired")}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom>
            {translate("labels.sessionExpiredMsg")}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variantStyle="primary"
            text={translate("labels.login")}
            onClick={handleClose}
          />
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}
